var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-down_svg__clip0_9427_17029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.193 3.464c.82 1.053 1.593 2.141 2.39 3.218.59.772 1.134 1.557 1.695 2.342a19.144 19.144 0 001.828 2.369c.81.815 1.569.04 2.173-.582a23.642 23.642 0 002.047-2.5c.567-.79 1.088-1.619 1.637-2.426.55-.806 1.135-1.515 1.657-2.286.52-.772-.728-1.471-1.255-.711l-2.93 4.197a24.992 24.992 0 01-1.67 2.143 7.202 7.202 0 00-.918.962c-.241.165-.153.216.268.164a4.413 4.413 0 01-.212-.257l-.471-.572c-1.716-2.226-3.267-4.582-5-6.796-.59-.72-1.817.026-1.24.747v-.012z",
    fill: "#5A2F56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-down_svg__clip0_9427_17029"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-90.833 7.043 6.944)",
    d: "M0 0h13.886v13.886H0z"
  })))));
}
export default SvgArrowDown;